module.exports = "/static/img/logo.0086b5f6d003b10bb4abb9b9abdab279.png";